import { memo } from "react";
import { Box } from "@mui/material";

const sx = {
  mb: 4,
  p: 2,
  border: "1px solid",
  borderColor: "error.dark",
  borderRadius: 1,
  color: "error.dark",
  backgroundColor: "error.main",
  fontSize: 14,
};

const ErrorMessage = ({ message }) => {
  if (!message) return null;
  return <Box sx={sx}>{message}</Box>;
};

export default memo(ErrorMessage);
